import PropTypes from 'prop-types';
import React from 'react';

import InformationModal from './InformationModal';
import { useGetLocalization } from '../../hooks';
import { ID_OPEN_VARIANCE_REASON_MODAL_BUTTON } from '../../utils/dom-element-ids';

// Base configuration for Variance Reason Modal
const BASE_VARIANCE_REASON_CONFIG = {
  titleKey: 'lbl.variance-reason-definitions',
  baseInformationList: [
    {
      item: 'lbl.variance-short',
      definition: 'lbl.variance-short-definition',
    },
    {
      item: 'lbl.variance-over',
      definition: 'lbl.variance-over-definition',
    },
  ],
  iconId: ID_OPEN_VARIANCE_REASON_MODAL_BUTTON,
  wrapperClassName: 'pb3-sm',
};

/**
 * Variance Reason Modal with support for additional dynamic reasons
 * Uses configuration-driven approach with optional additionalReasons prop
 */
function VarianceReasonModal({ modalTitle, additionalReasons }) {
  const getLocalization = useGetLocalization();

  const localizedBaseList = BASE_VARIANCE_REASON_CONFIG.baseInformationList.map(
    ({ item, definition }) => ({
      item: getLocalization(item),
      definition: getLocalization(definition),
    }),
  );

  // Combine base information list with additional reasons if provided
  const informationList = additionalReasons
    ? [...localizedBaseList, ...additionalReasons]
    : localizedBaseList;

  const content = (
    <InformationModal
      modalTitle={modalTitle || getLocalization(BASE_VARIANCE_REASON_CONFIG.titleKey)}
      informationList={informationList}
      iconId={BASE_VARIANCE_REASON_CONFIG.iconId}
    />
  );

  // Apply wrapper if configured
  if (BASE_VARIANCE_REASON_CONFIG.wrapperClassName) {
    return <div className={BASE_VARIANCE_REASON_CONFIG.wrapperClassName}>{content}</div>;
  }

  return content;
}

VarianceReasonModal.defaultProps = {
  modalTitle: null,
  additionalReasons: null,
};

VarianceReasonModal.propTypes = {
  modalTitle: PropTypes.string,
  additionalReasons: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.string.isRequired, // Already localized string
      definition: PropTypes.string.isRequired, // Already localized string
    }),
  ),
};

export default VarianceReasonModal;
